<template>
  <div class="sidebar">
    <h2 class="title">Minha Conta</h2>

    <nav class="navbar">
      <ul class="nav">
        <li class="nav__item">
          <router-link to="/account/orders" class="nav__link">
            <div class="nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30px"
                viewBox="0 0 640 512"
              >
                <path
                  d="M53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9zm585.1 102.8L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9z"
                />
              </svg>
            </div>
            <div class="nav__text">
              <span class="text__description">Pedidos</span>
            </div>
          </router-link>
        </li>
        <li class="nav__item">
          <a href="#" class="nav__link">
            <div class="nav__icon">
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                width="30px"
                viewBox="0 0 25 25"
              >
                <title>Location Pin</title>
                <path
                  id="Location_Pin"
                  data-name="Location Pin"
                  d="M12.5,0A9.24,9.24,0,0,0,3,9.41c0,7.88,8.8,15.17,9.17,15.47a.5.5,0,0,0,.65,0C13.21,24.53,22,16.51,22,9.41A9.24,9.24,0,0,0,12.5,0Zm0,14A4.5,4.5,0,1,1,17,9.5,4.5,4.5,0,0,1,12.5,14Z"
                />
              </svg>
            </div>
            <div class="nav__text">
              <span class="text__description">Endereços</span>
            </div></a
          >
        </li>
        <li class="nav__item">
          <router-link to="/account/profile" class="nav__link">
            <div class="nav__icon">
              <svg
                version="1.1"
                id="Layer_1_1_"
                xmlns="http://www.w3.org/2000/svg"
                width="25px"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 16 16"
                style="enable-background: new 0 0 16 16"
                xml:space="preserve"
              >
                <path
                  d="M12,9H8H4c-2.209,0-4,1.791-4,4v3h16v-3C16,10.791,14.209,9,12,9z"
                />
                <path
                  d="M12,5V4c0-2.209-1.791-4-4-4S4,1.791,4,4v1c0,2.209,1.791,4,4,4S12,7.209,12,5z"
                />
              </svg>
            </div>
            <div class="nav__text">
              <span class="text__description">Cadastro</span>
            </div>
          </router-link>
        </li>
        <li class="nav__item">
          <router-link
            to="/panel/dashboard"
            target="_blank"
            rel="noopener"
            class="nav__link nav__link--dashboard"
          >
            <div class="nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M10,14 C10.5522847,14 11,14.4477153 11,15 L11,21 C11,21.5522847 10.5522847,22 10,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,15 C2,14.4477153 2.44771525,14 3,14 L10,14 Z M21,9 C21.5522847,9 22,9.44771525 22,10 L22,21 C22,21.5522847 21.5522847,22 21,22 L14,22 C13.4477153,22 13,21.5522847 13,21 L13,10 C13,9.44771525 13.4477153,9 14,9 L21,9 Z M10,2 C10.5522847,2 11,2.44771525 11,3 L11,11 C11,11.5522847 10.5522847,12 10,12 L3,12 C2.44771525,12 2,11.5522847 2,11 L2,3 C2,2.44771525 2.44771525,2 3,2 L10,2 Z M21,2 C21.5522847,2 22,2.44771525 22,3 L22,6 C22,6.55228475 21.5522847,7 21,7 L14,7 C13.4477153,7 13,6.55228475 13,6 L13,3 C13,2.44771525 13.4477153,2 14,2 L21,2 Z"
                />
              </svg>
            </div>
            <div class="nav__text">
              <span class="text__description text__description--dashboard"
                >Acessar Painel</span
              >
            </div></router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vendedorResponsavel: null,
    };
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        this.vendedorResponsavel = dados.vendedorResponsavel;
      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 100%;

  @media (min-width: 441px) and (max-width: 768px) {
    width: 30%;
  }

  @media (min-width: 769px) {
    width: 20%;
  }

  .title {
    padding: 0 20px;

    @media (min-width: 441px) {
      font: 500 1.75rem "Soleto", sans-serif;
      padding: 0 0 20px 0;
      color: var(--customDarkGreen);
    }
  }

  .navbar {
    .nav {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      position: fixed;
      bottom: 0;
      background: var(--standardGreen);
      height: 80px;

      @media (min-width: 441px) {
        display: block;
        width: initial;
        position: initial;
        background: none;
        height: initial;
      }

      &__item {
        list-style: none;
        padding: 15px 0;

        &--active {
          color: red;
        }

        &:hover {
          .nav__link {
            color: var(--standardGreen);
          }

          svg {
            @media (min-width: 441px) {
              color: var(--standardGreen);
              fill: var(--standardGreen);
            }
          }
        }
      }

      &__link {
        text-decoration: none;
        color: var(--customGray-500);
        font: 700 1rem "Soleto", sans-serif;
        display: flex;
        align-items: center;

        svg {
          vertical-align: middle;
          color: var(--customWhite);
          fill: var(--customWhite);

          @media (min-width: 441px) {
            color: var(--customGray-500);
            fill: var(--customGray-500);
          }
        }

        &--dashboard {
          background: var(--customDarkGreen);
          color: var(--customWhite) !important;
          padding: 5px;
          border-radius: 5px;
          width: 70%;

          svg {
            fill: var(--customWhite);
          }
        }
      }

      &__icon {
        width: 15%;
      }

      &__text {
        width: 80%;

        .text {
          &__description {
            padding-left: 10px;
            display: none;

            @media (min-width: 441px) {
              display: block;
            }

            &--dashboard {
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>